// tl-variant-picker — Two Lions Fragrance v2
// Separa variantes de producto en:
//   MAIN_VARIANTS    → botones principales (comportamiento normal del tema)
//   EXCLUDED_VARIANTS→ ocultas en todas partes (no se muestran en ningún lado)
//   Resto            → dropdown "Otros productos de esta fragancia"
//
// También:
//   · Sobreescribe el precio "Desde S/. X" con el mínimo de variantes principales
//   · Traduce el mensaje de urgencia de stock y pinta la barra en negro

(function tlVariantPicker() {
  'use strict';

  // ── Configuración ──────────────────────────────────────────────────────────
  var MAIN_VARIANTS     = ['Perfume 30ml', 'Perfume 50ml', 'Perfume 100ml'];
  var EXCLUDED_VARIANTS = ['Perfume 15ml']; // Oculto en todas partes
  var SECONDARY_LABEL   = 'Otros productos de esta fragancia';
  var MAIN_MIN_PRICE    = 'Desde S/. 50.00';

  // ── Traducción y restyling del mensaje de stock urgente ─────────────────
  function patchStockMessages() {
    // Traduce nodos de texto con el mensaje de urgencia
    function translateNode(node) {
      if (node.nodeType === 3) {
        var t = node.textContent;
        var changed = false;
        if (/hurry up/i.test(t)) {
          t = t.replace(/hurry up!?/gi, '¡Date prisa!');
          changed = true;
        }
        if (/only\s+(\d+)\s+items?\s+left\s+in\s+stock/i.test(t)) {
          t = t.replace(/only\s+(\d+)\s+items?\s+left\s+in\s+stock!?/gi, 'Solo $1 unidades disponibles');
          changed = true;
        }
        if (changed) node.textContent = t;
      } else {
        node.childNodes.forEach(translateNode);
      }
    }

    // Selectores amplios que cubren distintos temas de Shopify
    var containers = document.querySelectorAll(
      '[class*="countdown"], [class*="urgency"], [class*="inventory-status"], ' +
      '[class*="low-stock"], [class*="stock-counter"], [class*="stock-bar"]'
    );
    containers.forEach(translateNode);

    // Fallback: área del formulario de producto
    var area = document.querySelector('.product-form, #product-form, [class*="product__info"]');
    if (area) translateNode(area.parentElement || area);

    // Pinta la barra de progreso de stock en negro
    document.querySelectorAll(
      '[class*="countdown"] [class*="fill"], [class*="countdown"] [class*="progress"], ' +
      '[class*="urgency"] [class*="fill"],   [class*="urgency"] [class*="bar"], ' +
      '[class*="inventory"] [class*="fill"], [class*="inventory"] [class*="bar"], ' +
      '[class*="stock"] [class*="fill"],     [class*="stock"] [class*="bar"], ' +
      '[class*="low-stock"] [class*="fill"], [class*="countdown__bar"]'
    ).forEach(function (el) {
      el.style.setProperty('background-color', '#000000', 'important');
      el.style.setProperty('background',       '#000000', 'important');
    });
  }

  // ── Precio "Desde" ─────────────────────────────────────────────────────
  // Reemplaza el precio mínimo global (que puede incluir variantes baratas como
  // Balsamo 10ml = S/45) con el mínimo de MAIN_VARIANTS (S/50 = Perfume 30ml).
  function patchFromPrice() {
    var checked = document.querySelector('input[name="Tamaño"]:checked');
    var isMain  = checked && MAIN_VARIANTS.indexOf(checked.value) >= 0;
    var isSecondary = checked && EXCLUDED_VARIANTS.indexOf(checked.value) < 0
                   && MAIN_VARIANTS.indexOf(checked.value) < 0;

    document.querySelectorAll(
      '.price.price-same-style, [class*="price--on-sale"] [class*="price-item--regular"], ' +
      '.price__regular .price-item, [class*="price-item"]'
    ).forEach(function (span) {
      var txt = (span.textContent || span.innerText || '').trim();

      // Solo parchear si el texto dice "Desde"
      if (txt.indexOf('Desde') === -1 && txt.indexOf('From') === -1) return;

      if (!checked || isMain || isSecondary) {
        // Extraer número del precio actual
        var m = txt.match(/[\d]+[.,]?\d*/);
        if (m) {
          var precio = parseFloat(m[0].replace(',', '.'));
          if (!isNaN(precio) && precio < 50) {
            span.textContent = MAIN_MIN_PRICE;
          }
        } else {
          // No se pudo parsear → forzar directamente
          span.textContent = MAIN_MIN_PRICE;
        }
      }
    });
  }

  // ── Core ───────────────────────────────────────────────────────────────────
  function run() {
    var inputs = document.querySelectorAll('input[name="Tamaño"][type="radio"]');
    if (!inputs.length) return;
    if (document.getElementById('tl-secondary-picker')) return; // ya inicializado

    var mainInputs      = [];
    var secondaryInputs = [];

    inputs.forEach(function (input) {
      var label = document.querySelector('label[for="' + input.id + '"]');
      var li    = input.closest('li');

      // Excluidas: ocultar en absolutamente todas partes
      if (EXCLUDED_VARIANTS.indexOf(input.value) >= 0) {
        input.style.display = 'none';
        if (label) label.style.display = 'none';
        if (li)    li.style.display    = 'none';
        return;
      }

      if (MAIN_VARIANTS.indexOf(input.value) >= 0) {
        mainInputs.push({ input: input, label: label, value: input.value });
      } else {
        secondaryInputs.push({ input: input, label: label, value: input.value });
      }
    });

    if (!secondaryInputs.length) return;

    // Ocultar secundarias del row de botones
    secondaryInputs.forEach(function (item) {
      if (item.label) item.label.style.display = 'none';
    });

    // Encontrar el fieldset / contenedor del picker
    var container = inputs[0].closest(
      'fieldset, .product__item-options, [class*="variant-picker"], [class*="product-form__input"]'
    );
    if (!container) {
      var p = inputs[0].parentElement;
      while (p && !p.contains(inputs[inputs.length - 1])) p = p.parentElement;
      container = p;
    }
    if (!container) return;

    // ── Crear dropdown ───────────────────────────────────────────────────────
    var wrapper = document.createElement('div');
    wrapper.id  = 'tl-secondary-picker';
    wrapper.setAttribute('style', 'margin-top:16px;');

    var lbl = document.createElement('p');
    lbl.setAttribute('style',
      'margin:0 0 8px;font-size:1.3rem;font-weight:600;' +
      'text-transform:uppercase;letter-spacing:.05em;opacity:.75;'
    );
    lbl.textContent = SECONDARY_LABEL;

    var selectWrap = document.createElement('div');
    selectWrap.setAttribute('style', 'position:relative;');

    var select = document.createElement('select');
    select.setAttribute('style', [
      'width:100%',
      'padding:12px 40px 12px 16px',
      'border:1px solid var(--color-border,rgba(0,0,0,.2))',
      'border-radius:var(--btn-radius,8px)',
      'background:var(--color-background,#fff)',
      'color:var(--color-text,inherit)',
      'font-size:1.4rem',
      'cursor:pointer',
      'appearance:none',
      '-webkit-appearance:none',
    ].join(';'));

    var arrow = document.createElement('span');
    arrow.setAttribute('aria-hidden', 'true');
    arrow.setAttribute('style',
      'pointer-events:none;position:absolute;right:14px;top:50%;transform:translateY(-50%);'
    );
    arrow.innerHTML =
      '<svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M1 1L7 7L13 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    // Placeholder
    var ph = document.createElement('option');
    ph.value       = '';
    ph.textContent = '— Seleccionar —';
    ph.disabled    = true;
    ph.selected    = true;
    select.appendChild(ph);

    secondaryInputs.forEach(function (item) {
      var opt = document.createElement('option');
      opt.value       = item.value;
      opt.textContent = item.value;
      select.appendChild(opt);
    });

    // Wiring: select → radio
    select.addEventListener('change', function () {
      var val = this.value;
      if (!val) return;
      secondaryInputs.forEach(function (s) {
        if (s.value === val) {
          s.input.checked = true;
          s.input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });

    // Wiring: main button click → reset select
    mainInputs.forEach(function (item) {
      item.input.addEventListener('change', function () {
        if (this.checked) select.value = '';
      });
      if (item.label) {
        item.label.addEventListener('click', function () { select.value = ''; });
      }
    });

    selectWrap.appendChild(select);
    selectWrap.appendChild(arrow);
    wrapper.appendChild(lbl);
    wrapper.appendChild(selectWrap);

    if (container.nextSibling) {
      container.parentNode.insertBefore(wrapper, container.nextSibling);
    } else {
      container.parentNode.appendChild(wrapper);
    }

    // Parchar precio y mensajes de stock
    requestAnimationFrame(function () {
      patchFromPrice();
      patchStockMessages();
    });
  }

  // ── Bootstrap ──────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.addEventListener('load', function () {
    run();
    patchStockMessages(); // Re-run después de que el tema termine de renderizar
    setTimeout(function () {
      run();
      patchFromPrice();
      patchStockMessages();
    }, 800);
  });

  // MutationObserver para cambios dinámicos del tema (precio actualizado por JS del tema)
  var _observer = new MutationObserver(function () {
    patchFromPrice();
    patchStockMessages();
  });

  document.addEventListener('DOMContentLoaded', function () {
    var priceArea = document.querySelector('.product__info-wrapper, .product-form, [class*="product-info"]');
    if (priceArea) {
      _observer.observe(priceArea, { childList: true, subtree: true, characterData: true });
    }
  });

})();
